import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Heart = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21 4C18.7 4 16.925 5.025 16 5.7C15.075 5.025 13.3 4 11 4C7.138 4 4 7.138 4 11C4 14.938 6 19.113 9.775 23.063C12.575 25.988 15.35 27.763 15.463 27.838C15.625 27.938 15.813 28.001 16 28.001C16.187 28.001 16.375 27.951 16.538 27.838C16.651 27.763 19.425 25.988 22.226 23.063C26.001 19.113 28.001 14.938 28.001 11C28.001 7.138 24.864 4 21.001 4H21ZM16 25.788C13.85 24.276 6 18.238 6 11.001C6 8.238 8.238 6.001 11 6.001C13.525 6.001 15.287 7.714 15.287 7.714C15.462 7.889 15.712 8.001 16 8.001C16.288 8.001 16.525 7.889 16.712 7.714C16.712 7.714 18.45 6.001 21 6.001C23.762 6.001 26 8.238 26 11.001C26 18.238 18.15 24.276 16 25.788Z" />
	</svg>
);

export default Heart;
